import EntityExtractionResult from 'owa-service/lib/contract/Item';
import Item from 'owa-service/lib/contract/Item';
import { action } from 'satcheljs/lib/legacy';

export default action('updateEntityExtractionResult')(function(
    item: Item,
    entityExtractionResult: EntityExtractionResult
) {
    item.EntityExtractionResult = entityExtractionResult;
});
